<template>
  <div class="ag-page_savedFilters position-relative">
    <ag-card :module="module"></ag-card>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import SavedFilters from "@/helpers/pages/SavedFilters";
import api from "@/store/axiosAgsc";
import { useStore } from "@/store";
import Swal from "sweetalert2";

const store = useStore();

export default defineComponent({
  name: "SavedFilters",
  components: { AgCard },
  data() {
    return {
      module: SavedFilters,
      data: [],
      filterTypes: [
        'assetPageFilter',
        'computerPageFilter',
        'eventPageFilter',
        'hashPageFilter',
      ]
    };
  },
  watch: {
    "$route.params.param"() {
      this.getList(this.currentParam);
    },
  },
  computed: {
    currentParam() {
      return this.$route.params.param;
    },
    getUserId() {
      return store.state.auth.user.filter((item) => item.type == "uid")[0]
        .value;
    },
  },
  methods: {
    deleteFunction(id) {
      Swal.fire({
        title: "Are You Sure?",
        icon: "warning",
        text: "You are about to delete the selected item!",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          api
            .delete("UserFilter/RemoveUserFilter?filterId=" + id)
            .finally(() => {
              this.getList(this.currentParam);
            });
        }
      });
    },
    getList(filterType) {
      this.module.component.options.isLoading = true;
      this.module.component.options.page = 1;
      api
        .get(
          "UserFilter/GetUserAllSavedFilters?userGuid=" + this.getUserId,
          null
        )
        .then((res) => {
          if (this.filterTypes.indexOf(filterType) > -1) {
            this.data = res.data.entityData[filterType];
          }

          this.data.forEach(function (element) {
            let template = "";
            let jsonData = JSON.parse(element.filterJsonData);

            jsonData.forEach(function (item) {
              if (item.selectedLabel || item.value?.selectedLabel) {
                let itemValue = item.selectedLabel
                  ? item.selectedLabel
                  : item.value.selectedLabel;
                template +=
                  "<div class='savedFilterItem'><strong>" +
                  item.name +
                  ": </strong><span>" +
                  itemValue +
                  "</span></div>";
              } else {
                template +=
                  "<div class='savedFilterItem'><strong>" +
                  item.name +
                  ": </strong><span>" +
                  item.value +
                  "</span></div>";
              }
            });

            element.filterJsonDataTemplate = template;
          });

          this.module.component.options.allData = this.data || [];
          this.module.component.options.allRows = this.data || [];
          this.module.component.options.rows = this.paginate(this.data, 5, 1) || [];
          this.module.component.options.total = this.data.length || [];
        })
        .finally(() => {
          this.module.component.options.isLoading = false;
        });
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
  },
  mounted() {
    this.getList(this.currentParam);
  },
});
</script>

<style>
.savedFilterItem {
  background: #e8e8e8;
  padding: 5px 8px;
  border-radius: 5px;
  margin: 0 5px;
  font-size: 13px;
  text-transform: capitalize;
  border: 1px solid #ddd;
}

.savedFilterItem strong {
  padding-right: 4px;
}

.ag-page_savedFilters table > tbody > tr > td:first-child span {
  font-size: 18px;
  color: #4c8dbb;
  align-items: center;
  height: 100%;
  display: flex;
}
</style>